<template>
  <section class="community">
    <div class="longImg"></div>
    <div class="content">
      <div class="space">
        <div class="s_head">
          <img src="../../assets/img/zuoj.png" alt="">
          <p>乐璟社·室内空间</p>
          <img src="../../assets/img/zuoj.png" alt="">
        </div>
        <div class="s_top">
          <div class="text">
            <p><span>2人间、4人间</span><span>独立私密空间</span></p>
            <p><span>双台盆</span><span>无线WIFI</span></p>
            <p><span>智能水电表</span><span>烟感</span></p>
            <p><span>中央热水24H</span><span>独立储物空间</span></p>
          </div>
          <div class="r_img"></div>
        </div>
        <div class="imgs">
          <div class="img1"></div>
          <div class="img2"></div>
          <div class="img3"></div>
        </div>
      </div>
      <div class="reform">
        <div class="r_head">
          <p>通过改建翻新，企业宿舍焕然一新</p>
          <div class="lineimg"></div>
        </div>
        <div class="r_imgs">
          <div class="img1"></div>
          <div class="img2"></div>
        </div>
      </div>
      <div class="public">
        <div class="p_head">
          <img src="../../assets/img/zuoj.png" alt="">
          <p>乐璟社·公区</p>
          <img src="../../assets/img/zuoj.png" alt="">
        </div>
        <div class="bg"></div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data () {
      return {
        id: ''
      }
    },
    mounted() {
    }
  }
</script>

<style lang="stylus" scoped>
  .community
    .longImg
      background:url(../../assets/img/bannerljs.png) no-repeat
      height: 600px
    .content
      font-family PingFangSC-Medium
      width 1120px
      margin 0 auto
      padding-bottom 180px
      .space
        margin-top 95px
        .s_head
          display: flex
          align-items: center
          justify-content: space-between
          p
            color #272727
            font-size 38px
            font-weight 500
          img:last-child
            transform rotate(180deg)
        .s_top
          margin-top 72px
          display flex
          align-items center
          justify-content space-between
          .text
            width 292px
            height 336px
            background-color #ECF8FA
            box-shadow:0px 2px 7px 0px rgba(13,36,61,0.1)
            padding 0 100px
            margin-left 28px
            p
              color #00B8D4
              font-size 18px
              line-height 44px
              font-weight 500
              display flex
              span
                width 50%
                display block
            p:first-child
              margin-top 90px
          .r_img
            width 562px
            height 388px
            background:url(../../assets/img/ljst1.png) no-repeat
        .imgs
          margin-top 8px
          display flex
          justify-content space-between
          div
            width 368px
            height 220px
          .img1
            background:url(../../assets/img/ljstu2.png) no-repeat
          .img2
            background:url(../../assets/img/ljstu3.png) no-repeat
          .img3
            background:url(../../assets/img/ljstu4.png) no-repeat
      .reform
        margin-top 115px
        .r_head
          color #272727
          font-size 38px
          font-weight 500
          p
            margin 0 0 26px 5px
          .lineimg
            background:url(../../assets/img/jiabl.png) no-repeat
            height 4px
        .r_imgs
          height 360px
          display flex
          justify-content space-between
          padding-top 36px
          .img1
            width 538px
            background:url(../../assets/img/ljsgzq.png) no-repeat
          .img2
            width 538px
            background:url(../../assets/img/ljsgzh.png) no-repeat
      .public
        margin-top 95px
        .p_head
          display: flex
          align-items: center
          justify-content: space-between
          p
            color #272727
            font-size 38px
            font-weight 500
          img:last-child
            transform rotate(180deg)
        .bg
          margin-top 83px
          height 578px
          background:url(../../assets/img/ljsgq.png) no-repeat
</style>
